import React from 'react';

const Rush: React.FC = () => {
  return (
    <div className="bg-purple-100 min-h-screen p-4">
      <div className="container mx-auto p-6 max-w-4xl bg-white shadow-lg rounded-lg my-6">
        <h1 className="text-4xl font-bold text-purple-800 text-center my-6">
          Fall Rush 2026
        </h1>

        <div className="space-y-6">

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🏐 Dodgeball 🏐</h2>
            <p className="font-bold">
              When: Saturday, 9/5, 2:30 PM – 3:30 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🔥 SAE Grill 🔥</h2>
            <p className="font-bold">
              When: Saturday, 9/5, 6:00 PM – 7:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">♠️ Poker Tournament ♠️</h2>
            <p className="font-bold">
              When: Saturday, 9/5, 8:30 PM – 10:30 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🚣 Rafting the Charles 🚣</h2>
            <p className="font-bold">
              When: Sunday, 9/6, 1:00 PM – 3:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🍗 Canes and Games 🎲</h2>
            <p className="font-bold">
              When: Sunday, 9/6, 5:00 PM – 7:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🍦 Late Night Ice Cream 🍦</h2>
            <p className="font-bold">
              When: Sunday, 9/6, 9:00 PM – 10:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🏖️ Beach Day 🏖️</h2>
            <p className="font-bold">
              When: Monday, 9/7, 1:00 PM – 3:30 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🍣 AYCE Sushi 🍣</h2>
            <p className="font-bold">
              When: Monday, 9/7, 5:00 PM – 7:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🎤 SAE Live 🎤</h2>
            <p className="font-bold">
              When: Tuesday, 9/8, 1:00 PM – 3:00 PM
            </p>
          </div>

          <div className="p-4 border-l-4 border-purple-600 bg-purple-50">
            <h2 className="text-2xl font-bold text-purple-700">🏆 SAE Taskmaster 🏆</h2>
            <p className="font-bold">
              When: Tuesday, 9/8, 4:00 PM – 6:00 PM
            </p>
          </div>

        </div>

        <div className="mt-6 text-sm text-gray-700">
          <p>
            The SAE house is a minute’s walk from the Silber Way stop on the Boston East SafeRide.
          </p>
          <p>
            Contact the Rush Chair: Regan Song (reggo)
          </p>
        </div>
      </div>
    </div>
  );
};

export default Rush;
